export default "__VITE_ASSET__C$uU$B57__"